import LoadingComponent from '@/pages/components/loadingComponent'
import Loadable from 'react-loadable'

export default [
  {
    component: Loadable({
      loader: () => import('@/pages/suppliersList/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/suppliersList',
    meta: {
      title: '交通工具'
    }
  }
]
